import { useEffect } from 'react';

export function useAlertOnTryLeave(enabled: boolean) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [enabled]);
}

export function useForceLinksNewTab(enabled: boolean) {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a');

      if (!link || !link.href) {
        return;
      }
      // allow download links
      if (link.hasAttribute('download')) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      window.open(link.href, '_blank', 'noopener');
    };

    document.addEventListener('click', handler, true);
    return () => document.removeEventListener('click', handler, true);
  }, [enabled]);
}
